export const TEMPLATE_REQUEST = "TEMPLATE_REQUEST";
export const TEMPLATE_UPDATE = "TEMPLATE_UPDATE";
export const TEMPLATE_UPDATED = "TEMPLATE_UPDATED";
export const TEMPLATE_DELETE = "TEMPLATE_DELETE";
export const TEMPLATE_CREATE = "TEMPLATE_CREATE";
export const TEMPLATE_ERROR = "TEMPLATE_ERROR";
export const TEMPLATE_LOADED = "TEMPLATE_LOADED";
